import * as actionType from "./Action_Type";
import { CALL_API } from '../Middlewares/api'
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import { LIBRA_GET_LIST, LIBRA_ADD_MODIFY, LIBRA_GET_TIPOLOGY_LIST, LIBRA_GET_MODEL_LIST } from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getListaBilance(filtri){
    var obj = {
    ID              : null,
    Porta           : filtri.Porta,
    MppPorta        : filtri.MppPorta,
    Nome            : filtri.Nome,
    Ip              : filtri.Ip,
    Matricola       : filtri.Matricola,
    Alias           : filtri.Alias,
    Codice          : filtri.Codice,
    AliasMpp        : filtri.AliasMpp,
    MppUtilizzo     : filtri.MppUtilizzo,
    Fiscale         : filtri.Fiscale,
    IDModello       : filtri.IDModello,
    IDTipologia     : filtri.IDTipologia,
    IDImpianto      : filtri.IDImpianto,
    IDAzienda       : filtri.IDAzienda,
    IDHolding       : filtri.IDHolding,
    Cancellata      : filtri.Cancellata,
    PeriodicaInizio : filtri.PeriodicaInizio,
    PeriodicaFine   : filtri.PeriodicaFine
    };
    return {
        [CALL_API]: {
            endpoint: LIBRA_GET_LIST+SGUri.serializeParameters(obj),
            authenticated: true,
            types: [
                        actionType.SERVICE_LIBRA_LIST_REQUEST, 
                        actionType.SERVICE_LIBRA_LIST_SUCCESS,
                        actionType.SERVICE_LIBRA_LIST_ERROR
                    ]
        }
    }
}

export function setBilancia(bilancia){
  return {
    [CALL_API]: {
      endpoint: LIBRA_ADD_MODIFY,
      method  : "POST",
      authenticated: true,
      types: [
                  actionType.SERVICE_LIBRA_SET_REQUEST, 
                  actionType.SERVICE_LIBRA_SET_SUCCESS,
                  actionType.SERVICE_LIBRA_SET_ERROR
              ],
      data : {
        ID                          : bilancia.ID                          || null,
        IDMaster                    : bilancia.IDMaster                    || null,
        Porta                       : bilancia.Porta                       || null,
        IntervalloAggiornamentoPeso : bilancia.IntervalloAggiornamentoPeso || null,
        IntervalloAggiornamentoIO   : bilancia.IntervalloAggiornamentoIO   || null,
        Nome                        : bilancia.Nome                        || null,
        Ip                          : bilancia.Ip                          || null,
        Matricola                   : bilancia.Matricola                   || null,
        Alias                       : bilancia.Alias                       || null,
        Codice                      : bilancia.Codice                      || null,
        DataUltimaModifica          : bilancia.DataUltimaModifica          || null,
        AliasMpp                    : bilancia.AliasMpp                    || null,
        Periodica                   : bilancia.Periodica                   || null,
        MppUtilizzo                 : bilancia.MppUtilizzo                 || false,
        MppPorta                    : bilancia.MppPorta                    || null,
        Fiscale                     : bilancia.Fiscale                     || null,
        Modello : {
          ID : bilancia.Modello == null ? null : bilancia.Modello.ID || null
        },
        Tipologia : {
          ID : bilancia.Tipologia == null ? null : bilancia.Tipologia.ID || null
        },
        Impianto : {
          ID : bilancia.Impianto == null ? null : bilancia.Impianto.ID || null
        },
        Cancellata : {
          Cancellata : bilancia.Cancellata == null ? null : bilancia.Cancellata.Cancellata || false
        }

      }
    }
  }
}

export const orderListaBilance = (holdList, value) => {
  return dispatch => {
     dispatch(requestList(actionType.SERVICE_LIBRA_LIST_REQUEST));
    dispatch(refreshList(sortList(holdList, value), actionType.SERVICE_LIBRA_REFRESH_LIST));
   }
}

export function getListaTipologieBilance(filtri){
    var obj = {
      ID   : filtri.ID,
      Tipo : filtri.Tipo
    };

    return {
        [CALL_API]: {
            endpoint: LIBRA_GET_TIPOLOGY_LIST+SGUri.serializeParameters(obj),
            authenticated: true,
            types: [
                        actionType.SERVICE_LIBRA_TIPOLOGIE_LIST_REQUEST, 
                        actionType.SERVICE_LIBRA_TIPOLOGIE_LIST_SUCCESS,
                        actionType.SERVICE_LIBRA_TIPOLOGIE_LIST_ERROR
                    ]
        }
    }
}

export function getListaModelliBilance(filtri){
    var obj = {
      ID               : filtri.ID,
      Nome             : filtri.Nome,
      PortaPredefinita : filtri.PortaPredefinita,
      IDTipologia      : filtri.IDTipologia
    }

    return {
        [CALL_API]: {
            endpoint: LIBRA_GET_MODEL_LIST+SGUri.serializeParameters(obj),
            authenticated: true,
            types: [
                        actionType.SERVICE_LIBRA_MODELLO_LIST_REQUEST, 
                        actionType.SERVICE_LIBRA_MODELLO_LIST_SUCCESS,
                        actionType.SERVICE_LIBRA_MODELLO_LIST_ERROR
                    ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Bilancia.js